import * as React from "react"
import * as TooltipPrimitive from "@radix-ui/react-tooltip"

import { cn } from "../../lib/utils"

const TooltipProvider = TooltipPrimitive.Provider

const Tooltip = TooltipPrimitive.Root

const TooltipTrigger = TooltipPrimitive.Trigger

/** Shared compact tooltip chrome (Radix + grid + sidebar). */
export const TOOLTIP_CONTENT_CLASS =
  "z-[100] max-w-xs px-2 py-1 text-xs font-normal leading-snug shadow-sm"

/** Truncated grid cells / long hints. */
export const TOOLTIP_HINT_CLASS = cn(
  TOOLTIP_CONTENT_CLASS,
  "max-w-md whitespace-normal break-words text-left"
)

const TOOLTIP_ANIMATION_CLASS =
  "animate-in fade-in-0 zoom-in-95 data-[state=closed]:animate-out data-[state=closed]:fade-out-0 data-[state=closed]:zoom-out-95 data-[side=bottom]:slide-in-from-top-2 data-[side=left]:slide-in-from-right-2 data-[side=right]:slide-in-from-left-2 data-[side=top]:slide-in-from-bottom-2"

const TooltipContent = React.forwardRef<
  React.ElementRef<typeof TooltipPrimitive.Content>,
  React.ComponentPropsWithoutRef<typeof TooltipPrimitive.Content>
>(({ className, side = "top", sideOffset = 6, ...props }, ref) => (
  <TooltipPrimitive.Portal>
    <TooltipPrimitive.Content
      ref={ref}
      side={side}
      sideOffset={sideOffset}
      className={cn(
        "overflow-hidden rounded-md border border-border/80 bg-popover text-popover-foreground",
        TOOLTIP_CONTENT_CLASS,
        TOOLTIP_ANIMATION_CLASS,
        className
      )}
      {...props}
    />
  </TooltipPrimitive.Portal>
))
TooltipContent.displayName = TooltipPrimitive.Content.displayName

export { Tooltip, TooltipTrigger, TooltipContent, TooltipProvider }
